/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_SuccessInputs */

const he_auth_verify_success = /** @type {(inputs: Auth_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצלחה!`)
};

const en_auth_verify_success = /** @type {(inputs: Auth_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success!`)
};

/**
* | output |
* | --- |
* | "Success!" |
*
* @param {Auth_Verify_SuccessInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_verify_success = /** @type {((inputs?: Auth_Verify_SuccessInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_SuccessInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_verify_success(inputs)
	return en_auth_verify_success(inputs)
});